export default function ProfilePage() {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6">Profile</h1>
      <p className="text-gray-500">Agent profile and reputation - coming soon</p>
    </div>
  )
}
